import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UserDetail } from 'src/app/Models/UserDetailsResponse';
import { AppComponent } from 'src/app/app.component'; 

@Component({
  selector: 'app-client-businesses',
  templateUrl: './client-businesses.component.html',
  styleUrls: ['./client-businesses.component.css']
})
export class ClientBusinessesComponent {
  displayedColumns: string[] = ['ClientName','ClientBusinessName','ClientEmail','ClientNumber','Created_On', 'ClientPermissionType', 'actions'];
  dataSource : any;
  UserId: string = "";
  ManagerUserId: string = "";
  ClientUserId: string = "";
  BusinessInfoId: string = "";
  FirstName: string = "";
  UserNameAsPhoto: string = "";
  ClientBusinessData: UserDetail[]=[];
  dataprsent : boolean = false;
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  constructor(public service: SharkifyAiSerivceService, public router : Router,public datepipe : DatePipe,public app: AppComponent) {}
  ngOnInit(): void {
    this.ManagerUserId = this.getSafeValue(localStorage.getItem("ManagerUserId"));
    this.app.displayLoader(true);
    this.service.ClientBusinessesHandledByManager(this.ManagerUserId).subscribe(data => {
      this.app.displayLoader(false);
      if (data.Code == 200) {
        this.ClientBusinessData=data.UserDetails;
        this.ClientBusinessData.forEach(element => {
          element.ClientFullName = element.ClientFirstName + ' ' + element.ClientLastName;
          element.ClientImageText= `${Array.from(element.ClientFullName)[0]}`;
          element.isImageAvailable = element.ClientPhoto == null || element.ClientPhoto == "" || element.ClientPhoto == "null" ? false : true;
          element.CreatedOn_text = element.CreatedOn == null || element.CreatedOn == undefined ? "" : this.datepipe.transform(element.CreatedOn,"dd-MMM-yyyy")+ "";
        });
        if(this.ClientBusinessData){
          this.dataprsent = true;
        }
        this.dataSource = new MatTableDataSource(this.ClientBusinessData);
      } else {
      }
    });
 
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
}
